export default __webpack_public_path__ + "070161ded9dd433d0fe00d45334a1010.svg";